<template>
  <div class="pagination">
    <button class="btn btn-pagination" :disabled="currentPage === 0" @click="skim('prev')">prev</button>
    <div class="flex flex-col items-center text-xs" v-if="pageRange.start">
      <div>{{ pageRange.start }}{{ pageRange.end }} / {{ totalItems }}</div>
      <div class="uppercase tracking-wider text-pink-400">Page {{currentPage + 1}} of {{totalPages}}</div>
    </div>
    <button class="btn btn-pagination" :disabled="finalPageInPagination" @click="skim('next')">next</button>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    itemsPerPage: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      // itemsPerPage: this.itemsPerPage, => prop
      // totalItems: null, => prop
      currentPage: 0,
      pageRange: {
        start: null,
        end: null
      },
      // Required for "next" button to eventually assign the disabled status
      finalPageInPagination: false,
      localDebugging: false
    }
  },
  computed: {
    totalPages () {
      const val = Math.ceil(this.totalItems / this.itemsPerPage)
      return val
    }
  },
  methods: {
    // "skim" = blättern
    skim (dir) {
      switch (dir) {
        case 'prev':
          // - decrease "pageCounter"
          // - Check, if is not -1 or larger (total % perPage) - set btn to disabled then
          // - call getPaginatedNotes with new offfset / limit
          // - set current page
          // - update any display of current page and / or page range

          this.currentPage = this.currentPage === 0
            ? 0
            : this.currentPage - 1

          this.calculatePageRange()
          this.$emit('onSkimmingThePages', this.currentPage)

          break

        case 'next':
          this.currentPage = (this.currentPage < Math.floor(this.totalItems / this.itemsPerPage))
            ? this.currentPage + 1
            : this.currentPage

          this.calculatePageRange()
          this.$emit('onSkimmingThePages', this.currentPage)

          break
      }
    },
    calculatePageRange () {
      // Will be recalculated in Watcher
      const firstItem = (this.itemsPerPage * this.currentPage) + 1
      let lastItem = (this.itemsPerPage * (this.currentPage + 1))

      if (lastItem > (this.totalItems - 1)) {
        // This happens on first run, but there are watchers who change this...
        lastItem = this.totalItems
        this.finalPageInPagination = true
      }
      else {
        // ... therefore this "else" must be set in order to
        //     set the variable to false again
        this.finalPageInPagination = false
      }

      // console.log('this.finalPageInPagination =', this.finalPageInPagination)
      // console.log('firstItem =', firstItem)
      // console.log('lastItem =', lastItem)

      this.pageRange.start = firstItem

      if (firstItem !== lastItem) {
        this.pageRange.end = ' – ' + lastItem
      }
      else {
        this.pageRange.end = ''
      }
    }
  },
  mounted () {
    // Done via watchers, not necessary here
    // this.calculatePageRange()
  },
  watch: {
    totalItems: function (newVal, oldVal) {
      // this will change due to the promise-based request to indexedDb
      // if (newVal !== oldVal) {
      // this.log = 'Pagination: watch - totalitems: oldVal = ' + oldVal + '<br>'
      // this.log = 'Pagination: watch - totalitems: newVal = ' + newVal + '<br>'
      this.calculatePageRange()
      // }
    },
    itemsPerPage: function (newVal, oldVal) {
      // this will change due to the promise-based request to indexedDb
      // if (newVal !== oldVal) {
      this.calculatePageRange()
      // }
    }
  }

}
</script>

<style lang="postcss" scoped>
.pagination {
  @apply flex items-center justify-between w-full;
  @apply border-t border-pink-700 pt-3;
  /* leave m-* to the implementation, because some need mt-auto!*/
}

.btn-pagination {
  @apply bg-pink-800 text-pink-200 rounded cursor-pointer transition;
}

.btn-pagination.disabled {
  @apply relative cursor-not-allowed opacity-80 text-pink-500;
}

.btn-pagination:not('disabed') {
  @apply bg-pink-700 text-pink-100;
}
</style>
